export class RequestMapper {
    public static readonly LOGIN: string = 'login';
    public static readonly SIDENAV: string = 'dashboard';
    public static readonly SELECT_CONTEXT: string = 'select-context';
    public static readonly FILTERANDSEARCH: string = 'filter-search-main';
    public static readonly PROFILE_SEARCH: string = 'profile-search';
    public static readonly DEVOTEE_COMPARE: string = 'devotee-compare';
    public static readonly CHANGE_PRIMARY_DEVOTEE: string = 'change-primary-devotee';
    public static readonly CHANGE_FC: string = 'change-fc';
    public static readonly MANUAL_UPDATE: string = 'manual-update';
    public static readonly OCCUPANCY_STATISTICS: string = 'occupancy-statistics';

    // Establishment (branch) screens — routes match the view webRoutes in
    public static readonly ESTAB_BOOKINGS: string = 'bookings';
    public static readonly ESTAB_CHECKIN_CHECKOUT: string = 'checkin-checkout';
    public static readonly ESTAB_PROPERTIES: string = 'properties';
    public static readonly ESTAB_UTSAV_SETUP: string = 'utsav-setup';
    public static readonly ESTAB_REPORTS: string = 'branch-reports';
    public static readonly ESTAB_BRANCH_CONFIG: string = 'branch-config';
    public static readonly ESTAB_STAFF: string = 'branch-staff';
    public static readonly MEDIA: string = 'media';
    public static readonly PLATFORM_REPORTS: string = 'platform-reports';

    // Check-in / Check-out Operator (CENTRAL front desk) — routes match the view
    public static readonly FD_DASHBOARD: string = 'checkin-dashboard';
    public static readonly FD_CHECKIN_DESK: string = 'checkin-desk';
    public static readonly FD_CHECKOUT_DESK: string = 'checkout-desk';
    public static readonly FD_BOOKING_SEARCH: string = 'booking-search';
    public static readonly FD_GUEST_HISTORY: string = 'guest-history';
    public static readonly FD_MY_ACTIVITY: string = 'my-activity';
    public static readonly FD_MY_PROFILE: string = 'my-profile';

    // Operator (CENTRAL provisioning)
    public static readonly PROV_DASHBOARD: string = 'provision-dashboard';
    public static readonly PROV_QUEUE: string = 'provision-queue';
    public static readonly PROV_MANUAL: string = 'manual-provision';
    public static readonly PROV_REQ_SEARCH: string = 'requisition-search';
    public static readonly PROV_DEVOTEE_UTILS: string = 'devotee-utilities';

    // Operator Admin (CENTRAL)
    public static readonly OA_UTSAV: string = 'utsav-management';
    public static readonly OA_BLOCK: string = 'accommodation-block';
    public static readonly OA_ADMIN_REQ: string = 'admin-requisitions';
    public static readonly OA_OPERATORS: string = 'operator-management';
    public static readonly OA_ROOM_CATALOGUE: string = 'room-catalogue';

    // Super Admin screens
    public static readonly SA_USERS: string = 'sa-users';
    public static readonly SA_ROLES: string = 'sa-roles';
    public static readonly SA_ESTABLISHMENTS: string = 'sa-establishments';
    public static readonly SA_VIEWS: string = 'sa-views';
    public static readonly SA_VIEW_AS_ROLE: string = 'sa-view-as-role';
}